var JSONdata = JSON.parse(JSON.stringify(require('../assets/environment-variables.json')));
export const environment = {
  production: false,
  redirectUrl: 'https://dasaua.testapps.alcoa.com/',
  clientId: JSONdata["dev"]["clientId"],
  tenantId: JSONdata["dev"]["tenantId"],
  authority: 'https://login.microsoftonline.com/37a72eb7-1faf-49d3-9ddc-6b923b751bc0/',
  WEBAPIURL: '/testapi',
  consentScopes: ["user.read"],
  scope: ["api://9546d955-4ebe-4257-9d83-bebe9d5de681.alcoa.com/user_impersonation"],
  AssetMaintenancePostSubscriptionKey: JSONdata["dev"]["AssetMaintenancePostSubscriptionKey"],
  FileUploadSize:20971520,
  AssetMaintenanceAPIUrl: "https://api.alcoa.com/assetmaintenance.QA/v2/entityName/",
  OracleDasAPIUrl: "https://api.alcoa.com/das.QA/v1/entityName/",
  AssetMaintenanceSubscriptionKey: JSONdata["dev"]["AssetMaintenanceSubscriptionKey"],
  AssetMaintenanceKey: JSONdata["dev"]["AssetMaintenanceKey"],
  
  // Application Insights - Replace with your instrumentation key
  appInsightsInstrumentationKey: JSONdata["dev"]["appInsightsInstrumentationKey"]
};
